module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MDAiIGhlaWdodD0iNjAwIiB2aWV3Qm94PSIwIDAgMjcgMTgiPjxwYXRoIGZpbGw9IiM0MTg5REQiIGQ9Ik0wIDBoMjd2MThIMFYweiIvPjxwYXRoIGZpbGw9IiNGOUQ2MTYiIGQ9Ik0wIDEyaDI3djFIMHYxaDI3djFIMHYtM3oiLz48cGF0aCBmaWxsPSIjRDIxMDM0IiBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iLjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTQuNjI1IDMuMzc1TDQgMS4zNWwtLjYyNSAyLjAyNUwxLjM1IDRsMi4wMjUuNjI1TDQgNi42NWwuNjI1LTIuMDI1TDYuNjUgNHoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/abw.svg
// module id = E0I8
// module chunks = 0